import React, { useState, useContext, useEffect } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import { CommonContext } from '../../../../context';
import { useLocation } from 'react-router-dom';
import CourierTable from './CourierTable';

const Courier = () => {
    const { user, onMerchantCourier, rowData } = useContext(CommonContext)
    let location = useLocation();
    useEffect(() => {
        if (rowData?.id) {
            onMerchantCourier(rowData?.id, rowData?.service_type);
        }
    }, [])
    return (
        <>
            <CourierTable />
        </>
    );
};

export default Courier;
